exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-loading[data-v-0fde5dcc] {\n  margin-right: 8px;\n}\n.btn-round[data-v-0fde5dcc] {\n  border-radius: 22px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0fde5dcc","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@finance/ssvue/src/components/x-button/index.vue
// module id = 252
// module chunks = 8